import Swiper from 'swiper/bundle';
import $ from 'jquery';

new Swiper('.team-member-block-members__sliders', {
    slidesPerView: 1.2,
    spaceBetween: 30,
    navigation: {
        nextEl: '.team-member-block__nav--next',
        prevEl: '.team-member-block__nav--prev',
    },
    breakpoints: {
        500: {
            slidesPerView: 2,
        },
        1200: {
            slidesPerView: 3,
        }
    }
});
